import { includes } from 'lodash';

let currentHash = {
  totalTime: 0,
  mainPlanSelected: false,
  planIdSelected: null,
  planIdViewed: [],
  clickBackMainPlan: false,
  clickBackPlans: false,
  viewMorePlans: false,
  plansPageHadScroll: false,
  plansPageScrolledToBottom: false,
  plansPageMaxScrolledPercentage: 0,
  plansPageScreenWidth: 0,
  plansPageScreenHeight: 0
};

const statInitialData = (init = {}) => {
  currentHash = {
    ...currentHash,
    ...{ initDate: Date.now() },
    ...init
  };
};

const selectMainPlan = (plan) => {
  currentHash.mainPlanSelected = true;
  currentHash.planIdSelected = plan.id;
};

const selectOtherPlan = (plan) => {
  currentHash.planIdSelected = plan.id;
};

const clickBack = (page) => {
  if (page === "mainPlan") {
    currentHash.clickBackMainPlan = true;
  } else if (page === "plans") {
    currentHash.clickBackPlans = true;
  }
};

const clickMorePlans = () => {
  currentHash.viewMorePlans = true;
};

const defineWindowWidth = () => (window.innerWidth || document.documentElement.clientWidth);
const defineWindowHeight = () => (window.innerHeight || document.documentElement.clientHeight);

const plansPageUpdateDimensions = (plansPageLastElRef = null, scrollPlansEls = null) => {
  currentHash.plansPageScreenWidth = defineWindowWidth();
  currentHash.plansPageScreenHeight = defineWindowHeight();
  if (plansPageLastElRef && scrollPlansEls) {
    plansPageScroll(plansPageLastElRef, scrollPlansEls)();
  }
};

const plansPageScroll = (plansPageLastElRef, scrollPlansEls) => (event) => {
  if (plansPageLastElRef.current) {
    const scrollTop = (
      window.pageYOffset || window.scrollY ||
      document.documentElement.scrollTop || document.body.scrollTop
    );

    const windowHeight = defineWindowHeight();

    const scrollEl = plansPageLastElRef.current.parentElement.firstChild;

    const maxScrollHeight = scrollEl.scrollHeight - windowHeight;
    const scrolledHeight = maxScrollHeight - scrollTop;

    const reachedBottom = (maxScrollHeight > 1) && (scrolledHeight <= 1);
    let scrolledPercentage = (
      maxScrollHeight > 0 ? (100 - Math.round(scrolledHeight * 100 / maxScrollHeight)) : 0
    );
    if (scrolledPercentage > 100) {
      scrolledPercentage = 100;
    }

    if (!currentHash.plansPageHadScroll) {
      currentHash.plansPageHadScroll = maxScrollHeight > 1;
    }
    if (!currentHash.plansPageScrolledToBottom) {
      currentHash.plansPageScrolledToBottom = reachedBottom;
    }
    if (scrolledPercentage > currentHash.plansPageMaxScrolledPercentage) {
      currentHash.plansPageMaxScrolledPercentage = scrolledPercentage;
    }
    for (const planId in (scrollPlansEls.current || {})) {
      checkPlanViewed(parseInt(planId, 10), scrollPlansEls.current[planId]);
    }
  }
};

const addPlanViewed = (planId) => {
  if (!includes(currentHash.planIdViewed, planId)) {
    currentHash.planIdViewed.push(planId);
  }
};

const checkPlanViewed = (planId, el) => {
  const box = el.getBoundingClientRect();
  const top = box.top;
  const bottom = top + box.height;
  const windowHeight = defineWindowHeight();
  if (top >= 0 && bottom <= windowHeight) {
    addPlanViewed(planId);
  }
};

const statSendData = (customData = {}) => {
  const postData = {
    kind: 'completeSurvey',
    result: {
      ...currentHash,
      ...customData,
      ...{ totalTime: Math.round((Date.now() - currentHash.initDate) / 1000) }
    }
  };

  (window.parent || window).postMessage(postData, "*");
};

export {
  statInitialData, statSendData,
  selectMainPlan, selectOtherPlan, clickBack, clickMorePlans,
  plansPageUpdateDimensions, plansPageScroll, checkPlanViewed, addPlanViewed
};
